const sizeClasses = {
    sm: 'py-[8px] px-[8px] text-[14px]',
    base: 'py-[12px] px-[30px] text-[16px] h-[44px]',
}

const variantClasses = {
    dark: 'bg-black text-white hover:bg-gray-800',
    light: 'bg-white/70 backdrop-blur-sm text-[#000D1E] hover:bg-white/90',
    outline:
        'bg-transparent text-dark-blue border border-dark-blue hover:bg-dark-blue/5',
    gray: 'bg-[#F5F5F6] text-dark-blue hover:bg-[#EBEBED]',
}

export default function Button({
    children,
    loading,
    disabled,
    onClick,
    size = 'base',
    variant = 'dark',
    fullWidth = false,
    icon,
}) {
    return (
        <button
            onClick={onClick}
            disabled={loading || disabled}
            className={`
                rounded-[8px] font-semibold
                flex items-center justify-center gap-2
                ${sizeClasses[size]}
                ${variantClasses[variant]}
                ${fullWidth ? 'w-full' : ''}
                ${loading || disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            `}
        >
            {icon && !loading && icon}
            {loading && (
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                        fill="none"
                    />
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                    />
                </svg>
            )}
            {children}
        </button>
    )
}
